<router-outlet />

@if (pending$ | async) {
  <emp-loader />
}
